import { Box, Text } from '@doist/marketist';
import cn from 'clsx';
import css from './text-lock-up.module.css';
import type { CSSProperties, ReactNode } from 'react';
type TextLockUpProps = {
  title: string;
  size?: 'lg' | 'base';
  preheader?: string;
  withoutWrapper?: boolean;
  children?: ReactNode;
  buttons?: ReactNode | ReactNode[];
  style?: CSSProperties;
};
function TextLockUp({
  size = 'base',
  withoutWrapper,
  preheader,
  title,
  children,
  buttons,
  style
}: TextLockUpProps) {
  return <Box className={cn(css[size], css.textLockUp)} style={style} data-sentry-element="Box" data-sentry-component="TextLockUp" data-sentry-source-file="text-lock-up.tsx">
            <Box className={css.textContainer} data-sentry-element="Box" data-sentry-source-file="text-lock-up.tsx">
                {preheader && <Text size={size === 'lg' ? 'minor-lg' : 'minor-base'} weight="bold" className={css.preheader}>
                        {preheader}
                    </Text>}
                <Text size={size === 'lg' ? 'major-lg' : 'major-base'} weight="bold" className={css.title} data-sentry-element="Text" data-sentry-source-file="text-lock-up.tsx">
                    {title}
                </Text>
                {children && <Text tag={withoutWrapper ? 'span' : 'p'} size={size === 'lg' ? 'body-lg' : 'body-base'} weight="medium" className={css.body}>
                        {children}
                    </Text>}
                {buttons && <Box className={css.buttonRow}>{buttons}</Box>}
            </Box>
        </Box>;
}
export { TextLockUp };